export default __webpack_public_path__ + "static/media/extjs.400b5181.jpg";